module.exports = __webpack_public_path__ + "img/31.0e29cc9d.png";